"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Card = void 0;

var _react = _interopRequireDefault(require("react"));

var _view = require("../view");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Card = function Card(_ref) {
  var children = _ref.children,
      extend = _ref.extend,
      noPadding = _ref.noPadding,
      props = _objectWithoutProperties(_ref, ["children", "extend", "noPadding"]);

  return /*#__PURE__*/_react["default"].createElement(_view.View, _extends({}, props, {
    extend: [rootCSS({
      noPadding: noPadding
    }), extend]
  }), children);
};

exports.Card = Card;

var rootCSS = function rootCSS(_ref2) {
  var noPadding = _ref2.noPadding;
  return function (_ref3) {
    var _ref3$theme = _ref3.theme,
        colors = _ref3$theme.colors,
        grid = _ref3$theme.grid,
        shadows = _ref3$theme.shadows,
        radius = _ref3$theme.radius;
    return {
      position: 'relative',
      padding: !noPadding ? 3 * grid : 0,
      background: colors.bg,
      boxShadow: shadows.big,
      transition: 'all 200ms ease-in-out',
      borderRadius: radius
    };
  };
};